export const dataSourceDefaultOptions = [
    'Map Field',
    'Fixed Value'
];

export const castAsDefaultOptions = [
    'String',
    'Integer',
    'Float',
    'Boolean',
];

export const uomLengthDefaultOptions = [
    'cm',
    'm',
    'mm',
    'in',
    'ft'
];

export const uomWeightDefaultOptions = [
    'kg',
    'g',
    'lb',
    'oz',
    'ton',
    'tonne',
    'cwt'
];